var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBucket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "510.000000pt",
    height: "459.000000pt",
    viewBox: "0 0 510.000000 459.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,459.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88 4570 c-46 -25 -79 -70 -85 -118 -2 -22 137 -891 346 -2162 290 -1759 355 -2132 374 -2170 29 -56 86 -97 156 -110 35 -6 643 -10 1720 -10 1600 0 1668 1 1707 19 48 22 80 60 94 110 5 20 166 996 356 2169 312 1918 346 2137 335 2172 -15 50 -61 96 -109 110 -25 7 -823 10 -2447 10 -2365 -1 -2411 -1 -2447 -20z m3252 -1531 c0 -6 -56 -339 -125 -740 -69 -401 -125 -734 -125 -739 0 -6 -192 -10 -535 -10 -308 0 -535 4 -535 9 0 5 -63 339 -140 741 -77 403 -140 737 -140 741 0 5 360 9 800 9 576 0 800 -3 800 -11z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBucket);
export default __webpack_public_path__ + "static/media/bucket.3da372dbfa071533e040186253434c1d.svg";
export { ForwardRef as ReactComponent };